import "./gsap";
import { initExamplePage } from "./example-page";
import "./landing";
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./animations";

/***************************************
 * Footer Newsletter toggle
 ***************************************/
document.querySelectorAll(".footer--newsletter__toggle").forEach((btn) => {
  btn.addEventListener("click", () => {
    btn.classList.toggle("active");
    const content = document.querySelector(".footer--newsletter__content");
    if (!content) return;
    const isHidden = content.style.display === "none" || !content.offsetHeight;
    content.style.display = isHidden ? "block" : "none";
  });
});

/***************************************
 * Fullscreen Slider
 ***************************************/
const fullscreenSlider = document.querySelector(".fullscreen-slider .swiper");
if (fullscreenSlider) {
  const swiper = new Swiper(fullscreenSlider, {
    modules: [Autoplay, EffectFade, Navigation, Pagination],
    slidesPerView: 1,

    loop: true,
    effect: "fade",
    spaceBetween: 30,
    fadeEffect: {
      crossFade: true,
    },

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination-fullscreen",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

/***************************************
 * Interior Sliders
 ***************************************/
const interiorSlider = document.querySelectorAll(".interior--styles .swiper");
if (interiorSlider.length > 0) {
  interiorSlider.forEach((slider) => {
    if (slider) {
      const swiper = new Swiper(slider, {
        modules: [Autoplay, Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 1000,
        watchSlidesProgress: true,
        grabCursor: false,
        effect: "fade",
        rtl: true,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-button-next.history",
          prevEl: ".swiper-button-prev.history",
        },
        pagination: {
          el: ".swiper-pagination-history",
          clickable: true,
        },
        breakpoints: {
          0: {
            allowTouchMove: true,
          },
          768: {
            effect: "slide",
            spaceBetween: 0,
            rtl: false,
            allowTouchMove: false,
            pagination: {
              enabled: false,
            },
          },
        },
      });
    }
  });
}

/***************************************
 * Home galerij slider
 ***************************************/
document.querySelectorAll(".home-gallery__slider").forEach((slider) => {
  const viewport = slider.querySelector(".home-gallery__viewport");
  if (!viewport) return;

  new Swiper(viewport, {
    modules: [Navigation, Pagination],
    slidesPerView: 1.15,
    spaceBetween: 16,
    grabCursor: true,
    navigation: {
      nextEl: slider.querySelector(".home-gallery__nav--next"),
      prevEl: slider.querySelector(".home-gallery__nav--prev"),
    },
    pagination: {
      el: slider.querySelector(".home-gallery__pagination"),
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });
});

/***************************************
 * Hamburger/menu
 ***************************************/
const hamburger = document.querySelector(".hamburger");
const header = document.getElementById("masthead");
const mobileMenu = document.querySelector(".site-header__mobile-menu");

if (hamburger && header && mobileMenu) {
  hamburger.addEventListener("click", () => {
    const isOpen = hamburger.classList.contains("active");
    hamburger.classList.toggle("active");
    hamburger.setAttribute("aria-expanded", String(!isOpen));
    mobileMenu.setAttribute("aria-hidden", String(isOpen));
    document.body.classList.toggle("no-scroll");
    document.documentElement.classList.toggle("no-scroll");
    header.classList.toggle("show");
    header.classList.remove("sticky");
    mobileMenu.classList.toggle("show");
    if (!isOpen) {
      const firstLink = mobileMenu.querySelector("a");
      if (firstLink) firstLink.focus();
    }
  });

  function closeFullscreenMenu() {
    hamburger.classList.remove("active");
    hamburger.setAttribute("aria-expanded", "false");
    mobileMenu.setAttribute("aria-hidden", "true");
    mobileMenu.classList.remove("show");
    document.body.classList.remove("no-scroll");
    document.documentElement.classList.remove("no-scroll");
    header.classList.remove("show");
    hamburger.focus();
    updateStickyHeader();
  }

  mobileMenu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeFullscreenMenu);
  });
}

/***************************************
 * Sticky header
 ***************************************/
function updateStickyHeader() {
  if (!header) return;
  if (window.scrollY > 30) {
    header.classList.add("sticky");
    header.classList.remove("normal");
  } else {
    header.classList.remove("sticky");
    header.classList.add("normal");
  }
}

window.addEventListener("scroll", updateStickyHeader, { passive: true });
updateStickyHeader();

/***************************************
 * Smooth scroll
 ***************************************/
document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])').forEach((anchor) => {
  anchor.addEventListener("click", (e) => {
    if (window.lenis) return;
    const url = new URL(anchor.href, location.href);
    if (url.pathname !== location.pathname || url.hostname !== location.hostname) return;

    const target = document.querySelector(url.hash) || document.querySelector(`[name="${url.hash.slice(1)}"]`);
    if (!target) return;

    e.preventDefault();
    const headerHeight = header ? header.offsetHeight : 0;
    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 50;
    window.scrollTo({ top, behavior: "smooth" });
  });
});

/***************************************
 * Example page — premium experience
 ***************************************/
document.addEventListener("DOMContentLoaded", initExamplePage);

/***************************************
 * Home — inschrijf-popup
 ***************************************/
function initHomeSignupPopup() {
  const popup = document.getElementById("signup-popup");
  if (!popup) return;

  const storageKey = "adw-signup-popup-dismissed";
  const openTriggers = document.querySelectorAll("[data-signup-popup-open]");
  const closeTriggers = popup.querySelectorAll("[data-signup-popup-close]");
  const dialog = popup.querySelector(".home-signup-popup__dialog");
  let autoOpenTimer;

  function openPopup() {
    window.clearTimeout(autoOpenTimer);
    popup.hidden = false;
    popup.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => {
      popup.classList.add("home-signup-popup--visible");
    });
    document.body.classList.add("no-scroll");
    document.documentElement.classList.add("no-scroll");

    const focusTarget = popup.querySelector(".twb-form__input, .home-signup-popup__email");
    if (focusTarget) {
      focusTarget.focus();
    }
  }

  function closePopup() {
    popup.classList.remove("home-signup-popup--visible");
    popup.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-scroll");
    document.documentElement.classList.remove("no-scroll");
    sessionStorage.setItem(storageKey, "1");

    window.setTimeout(() => {
      if (!popup.classList.contains("home-signup-popup--visible")) {
        popup.hidden = true;
      }
    }, 350);
  }

  openTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      openPopup();
    });
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener("click", closePopup);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && popup.classList.contains("home-signup-popup--visible")) {
      closePopup();
    }
  });

  if (dialog) {
    dialog.addEventListener("click", (event) => {
      event.stopPropagation();
    });
  }

  if (!sessionStorage.getItem(storageKey)) {
    autoOpenTimer = window.setTimeout(openPopup, 2000);
  }
}

document.addEventListener("DOMContentLoaded", initHomeSignupPopup);
